import { ActionCreator } from 'redux';

import * as ActionTypes from './actionTypes';

/**
 * Redux actions for login form workflow
 */

export const showLoginFormAction: ActionCreator<ActionTypes.IShowLoginAction> = () => ({
  type: ActionTypes.APP_LOGIN_SHOW,
});

export const updateEmailAction: ActionCreator<ActionTypes.IUpdateEmailAction> = (email) => ({
  type: ActionTypes.APP_LOGIN_EMAIL_UPDATE,
  payload: { email },
});

export const updatePasswordAction: ActionCreator<ActionTypes.IUpdatePasswordAction> = (password) => ({
  type: ActionTypes.APP_LOGIN_PASSWORD_UPDATE,
  payload: { password },
});

export const submitLoginFormAction: ActionCreator<ActionTypes.ISubmitAction> = () => ({
  type: ActionTypes.APP_LOGIN_SUBMIT,
});

export const showLoginFormErrorAction: ActionCreator<ActionTypes.IErrorAction> = (error) => ({
  type: ActionTypes.APP_LOGIN_ERROR,
  payload: { error },
});

export const cleanLoginFormErrorAction: ActionCreator<ActionTypes.IErrorCleanAction> = (field) => ({
  type: ActionTypes.APP_LOGIN_ERROR_CLEAN,
  payload: { field },
});

export const successLoginFormAction: ActionCreator<ActionTypes.ISuccessAction> = () => ({
  type: ActionTypes.APP_LOGIN_SUCCESS,
});
